import { useTranslations } from 'next-intl'

import { useFormatCurrency } from '@/shared/lib'

type Props = {
  finalPayFee: number
  label?: string
}

export const Price = ({ finalPayFee, label: labelProp }: Props) => {
  const t = useTranslations()

  const { formatCurrency } = useFormatCurrency()

  const label = labelProp ?? t('card_payment.floating_bar.label.payment_amount')

  return (
    <div className="flex items-center gap-2">
      <span className="typo-caption1 font-normal text-purple-300">{label}</span>
      <span className="typo-headline3 font-semibold text-white">
        {formatCurrency(finalPayFee)}
      </span>
    </div>
  )
}
